module.exports = __webpack_public_path__ + "static/Plaak - 33-Pradel-Regular-205TF-d21870b7ea747c88293782ec334f18aa.woff";